import { render, staticRenderFns } from "./PendingInvestmentRequests.vue?vue&type=template&id=68a82984&"
import script from "./PendingInvestmentRequests.vue?vue&type=script&lang=js&"
export * from "./PendingInvestmentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports